import "./VerticalLine.scss";

type Props = {
    className?: string;
};

export const VerticalLine = (props: Props) => {
    return (<div className={"VerticalLine px-2"}><div className={"h-100 w-100 border-end  " + (props.className || "")}></div></div>);
};
